import { Chain } from "@paywithglide/glide-js";
import ModalBackButton from "../components/ModalBackButton";

type Props = {
  chains: Chain[];
  onBack?: () => void;
};

export default function SupportedChainsList({ chains, onBack }: Props) {
  return (
    <div className="flex flex-col">
      {onBack ? <ModalBackButton onClick={onBack} /> : null}

      <div className="mb-4 mt-1.5 flex flex-col items-center justify-center">
        <div className="font-semibold text-[--color-text-primary]">
          Supported chains
        </div>
      </div>

      <div className="relative">
        <div className="h-full overflow-y-auto overflow-x-hidden px-0.5 [mask-image:linear-gradient(to_bottom,black_calc(100%-40px),transparent_100%)]">
          <div className="space-y-1 pb-4">
            {chains.map((chain) => (
              <div
                key={`${chain.id}-${chain.name}`}
                className="flex items-center gap-2.5 px-2.5 py-2 rounded-xl bg-[--color-background-secondary] border border-[--color-modal-border] hover:bg-[--color-background-secondary]/70 transition-colors cursor-pointer"
              >
                <img
                  src={chain.logoUrl}
                  alt={`${chain.name} Logo`}
                  className="h-8 w-8 rounded-full flex-shrink-0 transition-opacity duration-200"
                  loading="eager"
                  onLoad={(e) => {
                    e.currentTarget.style.opacity = "1";
                  }}
                  onError={(e) => {
                    e.currentTarget.style.opacity = "0.5";
                    e.currentTarget.style.backgroundColor = "#f3f4f6";
                  }}
                  style={{ opacity: 0 }}
                />
                <span className="text-sm font-medium text-[--color-text-primary]">
                  {chain.name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
